import React, {useMemo} from 'react';
import {cancelOrderAdmin, setOrderStatus} from '../../http/ordersAPI';
import {normalizeOrderStatusCode} from '../../util/Constants';
import {ORDER_FLOW_STEPS} from '../orders/OrderStatusTimeline';

const OrderControlForm = ({id, setIsPaid, setFeedback, orderStatus, setOrder, reloadOrder}) => {
    const statusesOrdered = useMemo(() => ORDER_FLOW_STEPS.map((x) => x.code), []);

    const norm = normalizeOrderStatusCode(orderStatus);
    const idx = statusesOrdered.indexOf(norm);

    const patchStatus = (next) => {
        if (!next || next === norm) return;
        setOrderStatus(id, next)
            .then((data) => setOrder(data))
            .catch((error) => setFeedback(error.response?.data?.message || error.message || String(error)));
    };

    const goPrev = () => {
        if (idx <= 0) return;
        patchStatus(statusesOrdered[idx - 1]);
    };

    const goNext = () => {
        if (idx < 0 || idx >= statusesOrdered.length - 1) return;
        patchStatus(statusesOrdered[idx + 1]);
    };

    const cancel = () => {
        if (!window.confirm('Отменить заказ? Это действие нельзя отменить.')) {
            return;
        }
        cancelOrderAdmin(id)
            .then(() => {
                setIsPaid(-1);
                setFeedback('');
                return reloadOrder();
            })
            .catch((error) =>
                setFeedback(error.response?.data?.message || error.message || String(error)),
            );
    };

    return (
        <div className="flex flex-wrap items-center gap-2">
            <button
                type="button"
                onClick={goPrev}
                disabled={idx <= 0}
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-pine-600 bg-pine-900 text-lg font-bold text-cream-100 shadow-sm hover:bg-pine-800 disabled:cursor-not-allowed disabled:opacity-35"
                aria-label="Предыдущий этап"
                title="Предыдущий этап"
            >
                ←
            </button>
            <button
                type="button"
                onClick={goNext}
                disabled={idx < 0 || idx >= statusesOrdered.length - 1}
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-pine-600 bg-pine-900 text-lg font-bold text-cream-100 shadow-sm hover:bg-pine-800 disabled:cursor-not-allowed disabled:opacity-35"
                aria-label="Следующий этап"
                title="Следующий этап"
            >
                →
            </button>
            <button
                type="button"
                onClick={cancel}
                className="lut-btn-danger h-10 shrink-0 rounded-xl border-2 border-red-400/60 bg-red-900 px-4 text-sm font-semibold text-red-50 hover:bg-red-800"
            >
                Отменить заказ
            </button>
        </div>
    );
};

export default OrderControlForm;
